import { render, staticRenderFns } from "./RowChildCountOre.vue?vue&type=template&id=57ace7cc&scoped=true"
import script from "./RowChildCountOre.vue?vue&type=script&lang=js"
export * from "./RowChildCountOre.vue?vue&type=script&lang=js"
import style0 from "./RowChildCountOre.vue?vue&type=style&index=0&id=57ace7cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ace7cc",
  null
  
)

export default component.exports